import { useEffect, useRef } from "react";

// Rafraîchit périodiquement les données ET immédiatement quand l'utilisateur
// revient sur l'onglet/fenêtre. Ne recharge pas si l'onglet est masqué (économie).
// fn : fonction de chargement idempotente et silencieuse. ms : intervalle.
export function useAutoRefresh(fn, ms = 15000) {
  const ref = useRef(fn);
  ref.current = fn;

  useEffect(() => {
    const run = () => {
      if (document.visibilityState === "visible") ref.current();
    };
    const id = setInterval(run, ms);
    window.addEventListener("focus", run);
    document.addEventListener("visibilitychange", run);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", run);
      document.removeEventListener("visibilitychange", run);
    };
  }, [ms]);
}
